import {Form, Input, notification} from "@ui";
import {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {PrimaryButton, SecondaryButton} from "@/components/Button";
import useGetUserInfo from "../../../hooks/useGetUserInfo";
import useUpdateProfile from "../../../hooks/useUpdateProfile";
import {useBalanceStore} from "../../../store/useBalance.store";
import BaseModal from "../../BaseModal/index";

const PagoMovilRegistrationModal = () => {
  const {t} = useTranslation();
  const [form] = Form.useForm();
  const {pagoMovilRegistrationModalVisible, handlePagoMovilRegistrationModal} = useBalanceStore();
  const {data: userData, refetch: refetchUserData} = useGetUserInfo();
  const {postUpdate, isPending, error} = useUpdateProfile(() => {
    notification.success({
      message: t("pagoMovilRegistrationSuccessTitle"),
      description: t("pagoMovilRegistrationSuccessMessage"),
    });
    handlePagoMovilRegistrationModal();
    refetchUserData();
  });

  const handleSubmit = values => {
    postUpdate({
      nationalID: values.cedula,
      phoneNumber: values.phoneNumber,
    });
  };

  const handleClose = () => {
    form.resetFields();
    handlePagoMovilRegistrationModal();
  };

  useEffect(() => {
    if (error) {
      notification.error({
        message: t("pagoMovilRegistrationErrorTitle"),
        description: t("pagoMovilRegistrationErrorMessage"),
      });
    }
  }, [error, t]);

  return (
    <BaseModal
      title={t("pagoMovilRegistrationTitle")}
      state={pagoMovilRegistrationModalVisible}
      closeModal={handleClose}
      width={420}
    >
      <p style={{color: "var(--theme-text-soft)", fontSize: 13, marginBottom: 16}}>
        {t("pagoMovilRegistrationMessage")}
      </p>
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          cedula: userData?.nationalID || "",
          phoneNumber: userData?.phoneNumber || "",
        }}
      >
        <Form.Item
          name="cedula"
          label={t("pagoMovilRegistrationCedula")}
          rules={[
            {required: true, message: t("pagoMovilRegistrationCedulaMessage")},
            {pattern: /^[0-9]+$/, message: t("pagoMovilRegistrationCedulaValidation")},
            {min: 7, message: t("pagoMovilRegistrationCedulaMinLength")},
            {max: 15, message: t("pagoMovilRegistrationCedulaMaxLength")},
          ]}
        >
          <Input placeholder={t("pagoMovilRegistrationCedulaPlaceholder")} />
        </Form.Item>
        <Form.Item
          name="phoneNumber"
          label={t("pagoMovilRegistrationPhoneNumber")}
          rules={[
            {required: true, message: t("pagoMovilRegistrationPhoneNumberMessage")},
            {pattern: /^[0-9+\-\s()]+$/, message: t("pagoMovilRegistrationPhoneValidation")},
            {min: 10, message: t("pagoMovilRegistrationPhoneMinLength")},
          ]}
        >
          <Input placeholder={t("pagoMovilRegistrationPhoneNumberPlaceholder")} />
        </Form.Item>
        <Form.Item style={{marginBottom: 0}}>
          <div className="form-modal-footer">
            <SecondaryButton onClick={handleClose}>{t("pagoMovilRegistrationCancelBtn")}</SecondaryButton>
            <PrimaryButton
              htmlType="submit"
              loading={isPending}
            >
              {t("pagoMovilRegistrationSubmitBtn")}
            </PrimaryButton>
          </div>
        </Form.Item>
      </Form>
    </BaseModal>
  );
};

export default PagoMovilRegistrationModal;
